module.exports = __webpack_public_path__ + "static/media/background.7a047a56.svg";